import React from "react";

export default function Transactions() {
  return (
    <div className="text-gray-600">
      <div className="header">Log a transaction</div>
    </div>
  );
}
